import { useFormContext } from "react-hook-form";
import type { UseMutationOptions } from "react-query";
import { useMutation, useQueryClient } from "react-query";
import { useWorkflowsApi } from "@/react/api";

export const useDeleteAction = (
  options: UseMutationOptions<undefined, Error, string> = {},
) => {
  const { watch } = useFormContext();
  const workflowId = watch("id") as string;
  const queryClient = useQueryClient();
  const workflowsApi = useWorkflowsApi();

  const deleteAction = (id: string) =>
    workflowsApi.deleteAction({
      workflowId,
      id,
    });

  return useMutation((id: string) => deleteAction(id), {
    ...options,
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries(["workflows", workflowId]);
      void options.onSuccess?.(data, variables, context);
    },
  });
};
